import styles from './index.module.less';
import { ImageWithCardArt } from '../image-with-card-art';
import { VAlign, Size } from '../../../core/enums';
import { BackgroundImage } from '../../atoms/background-image';
import { Row, Column } from '../../atoms/grid';
import { useBreakpoint } from '../../styleless/breakpoint';
import Element from '../../../core/Element';

interface Props {
  data: {
    body: React.ReactNode;
    imageUrl: string | { [key: string]: string };
    cardImage?: string;
    cardImageAlt?: string;
  };
  $bodyPosition?: 'left' | 'right';
  $bodyContentPosition?: VAlign;
  $cardSize?: {
    sm?: Size;
    md?: Size;
    lg?: Size;
  };
  $cardOffsetPosition?: boolean;
  $flipBackgroundImage?: boolean;
  qeId?: string;
}

const DEFAULT_CARD_SIZE_BY_BREAKPOINT = {
  sm: Size.SM,
  md: Size.LG,
  lg: Size.MD,
};

export const ContentBannerWithImageAndCard = ({
  data: { body, imageUrl, cardImage, cardImageAlt },
  $bodyPosition = 'right',
  $bodyContentPosition = VAlign.Top,
  $cardSize = {},
  $cardOffsetPosition = true,
  $flipBackgroundImage,
  qeId = 'ContentBannerWithImageAndCard',
}: Props) => {
  const { current, lg } = useBreakpoint();
  const cardSizes = {
    ...DEFAULT_CARD_SIZE_BY_BREAKPOINT,
    ...$cardSize,
  };

  return (
    <div data-qe-id={qeId} className={styles.root}>
      <Row>
        {/* Image Column */}
        <Column
          $lg="5"
          $lgPosition={$bodyPosition === 'left' ? 'last' : 'first'}
        >
          <div className={styles.imageColumn}>
            <div className={styles.cardWithBg}>
              {cardImage ? (
                <ImageWithCardArt
                  data={{
                    cardImage,
                    cardImageAlt,
                    backgroundImage:
                      typeof imageUrl === 'object'
                        ? imageUrl[current] || imageUrl._default
                        : imageUrl,
                  }}
                  $position={
                    !$cardOffsetPosition
                      ? 'center'
                      : lg
                        ? $bodyPosition
                        : 'bottom'
                  }
                  $cardSize={cardSizes[current]}
                  $flipBackgroundImage={$flipBackgroundImage}
                  customization={{
                    backgroundImagePosition: {
                      horizontal: lg ? 'right' : 'center',
                      vertical: lg ? 'center' : 'top',
                    },
                  }}
                />
              ) : (
                <div className={styles.cardWithBg}>
                  <BackgroundImage
                    imageUrl={
                      typeof imageUrl === 'string'
                        ? imageUrl
                        : imageUrl[current] || imageUrl._default
                    }
                    $fullWidth
                  />
                </div>
              )}
            </div>
          </div>
        </Column>

        {/* Text Column */}
        <Column $lg="7" $lgAlign={$bodyContentPosition}>
          <Element theme={{ padding: 5, paddingTop: 20, paddingBottom: 20 }}>
            {body}
          </Element>
        </Column>
      </Row>
    </div>
  );
};
